module.exports = __webpack_public_path__ + "static/media/SeaLighthouse-night.9c2b4eed.svg";